import { apiFetch } from '../api-client';

export interface InitialBalanceRow {
  id: string;
  year: number;
  accountCode: string;
  name: string;
  type: string;
  debit: number;
  credit: number;
  locked: boolean;
}
export interface InitialBalanceSummary {
  totalDebit: number; totalCredit: number; balanced: boolean;
  count: number; nonZeroCount: number; locked: boolean;
}
export interface CarryForwardResult {
  fromYear: number; toYear: number;
  created: number; updated: number;
  skippedNotPermanent: number; skippedLocked: number; skippedExisting: number;
  message: string;
}
export const initialBalancesApi = {
  list: (year?: number) => apiFetch<{ year: number; items: InitialBalanceRow[]; summary: InitialBalanceSummary }>(
    year ? `/api/initial-balances?year=${year}` : '/api/initial-balances',
  ),
  upsert: (year: number, accountCode: string, debit: number, credit: number) =>
    apiFetch<{ id: string }>('/api/initial-balances', {
      method: 'POST', body: JSON.stringify({ year, accountCode, debit, credit }),
    }),
  remove: (id: string) => apiFetch<{ ok: true }>(`/api/initial-balances/${id}`, { method: 'DELETE' }),
  lock: (year: number) => apiFetch<{ ok: true; lockedCount: number }>(`/api/initial-balances/${year}/lock`, { method: 'POST' }),
  unlock: (year: number) => apiFetch<{ ok: true }>(`/api/initial-balances/${year}/unlock`, { method: 'POST' }),
  carryForward: (fromYear: number, toYear: number, overwrite = false) =>
    apiFetch<CarryForwardResult>('/api/initial-balances/carry-forward', {
      method: 'POST', body: JSON.stringify({ fromYear, toYear, overwrite }),
    }),
};
